import React, { FC, useEffect, useRef, useState } from 'react';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import QuestionBox from 'src/components/molecules/content/QuestionBox';

interface Props {
  viewType?: string;
}

const Spouse: FC<Props> = ({ viewType }) => {
  const queStyle = { width: '400px' };
  const queSet = {
    question: [
      {
        idx: 0,
        status: 'this',
        confirm: '',
        set: {
          question: '직계존속과 동일한 주소에 거주하면서 생계를 같이하고 있나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: 1,
        status: 'ready',
        confirm: '',
        set: {
          question: '직계존속이 60세 이상인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: <div className="_text">2025년 귀속 연말정신시:1965.12.31 이전 출생자</div>,
              },
            ],
          },
        },
      },
      {
        idx: 2,
        status: 'ready',
        set: {
          question: '직계존속이 소득이 있나요?',
          style: queStyle,
          desc: [],
        },
      },
      {
        idx: 3,
        status: 'ready',
        set: {
          question: '직계존속이 근로소득만 있나요?',
          style: queStyle,
          desc: [],
        },
      },
      {
        idx: 4,
        status: 'ready',
        set: {
          question: '직계존속이 총급여액이 500만원 이하인가요?',
          style: queStyle,
          desc: [],
        },
      },
    ],
    answer: {
      status: 'ready',
      set: {
        title: '기본공제를 받을 수 있습니다.',
        status: 'yes',
        desc: {
          data: [
            {
              text: (
                <div className="_text">이때, 총 급여액은 비과세 소득을 제외한 금액을 말합니다.</div>
              ),
            },
          ],
        },
      },
    },
  };

  const [queState, setQueState] = useState({ set: queSet.question });
  const [awsState, setAwsState] = useState({ set: queSet.answer });

  useEffect(() => {
    const queEndStatus = queState.set.filter((item: any) => item.status !== 'end');
    const queConfirmStatus = queState.set.filter((item: any) => item.confirm === 'yes');

    if (queEndStatus.length === 0) {
      awsState.set.status = 'end';
      if (queState.set.length !== queConfirmStatus.length) {
        awsState.set.set.title = '기본공제를 받을 수 없습니다.';
        awsState.set.set.status = 'no';
      } else {
        awsState.set.set.title = '기본공제를 받을 수 있습니다.';
        awsState.set.set.status = 'yes';
      }

      setAwsState({ set: awsState.set });
    } else {
      awsState.set.status = 'ready';
      setAwsState({ set: awsState.set });
    }
  }, [queState]);

  return (
    <div className="_spouse_question_div">
      <QuestionBox
        queSet={queSet}
        queState={queState}
        setQueState={setQueState}
        awsState={awsState}
        setAwsState={setAwsState}
      />
    </div>
  );
};

export default Spouse;
